<template>
    <v-data-table v-bind="{ items, headers }" mobile-breakpoint="10000" disable-pagination disable-sort hide-default-footer class="v-sheet--outlined nshop-order-view-section">
        <template #top> <div class="table-label px-1 white">회원정보</div> </template>
        <template v-for="(header, index) in headers.filter((h) => h.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
    </v-data-table>
</template>

<script>
import { initDataTableHeaders } from "@/assets/lib";

export default {
    props: {
        order: { type: Object, default: () => ({}) },
    },
    computed: {
        items() {
            return [this.order];
        },
        headers() {
            return initDataTableHeaders([
                { text: "이름", value: "member.name" },
                { text: "전화번호", value: "member.phone" },
                { text: "아이디", value: "member.username" },
            ]);
        },
    },
};
</script>
